import { IconWorld } from '@calendly/ui/components/glyphs/IconWorld'
const colorIconStandard = 'var(--colorIconStandard, var(--coreColorNeutral800))'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { getTimezoneName } from '@calendly/timezone-tools'
import { DetailsItem as Item } from '@calendly/booking-kit'

export default ({ value, bookingAppRedesign = false }) => (
  <Item>
    <UiIcon
      icon={IconWorld}
      size={bookingAppRedesign ? 'small' : 'medium'}
      color={colorIconStandard}
      spacingRight="8"
      data-id="details-item-icon"
    />
    {getTimezoneName(value)}
  </Item>
)
